import { FC } from 'react'

type propsType = {
    styles: object
};

export const WhatsAppIcon1: FC<propsType> = ({ styles }) => {
    return (
        <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1280 1280"
        //style={{ enableBackground: "new 0 0 1280 1280" }}
        xmlSpace="preserve"
        style={{ ...styles }}
        >
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                __html:
                    "\n\t.st0{opacity:0;fill:#A7A9AC;}\n\t.st1{opacity:0.0217;fill:#A7A9AC;}\n\t.st2{opacity:0.0435;fill:#A7A9AC;}\n\t.st3{opacity:0.0652;fill:#A7A9AC;}\n\t.st4{opacity:0.087;fill:#A7A9AC;}\n\t.st5{opacity:0.1087;fill:#A7A9AC;}\n\t.st6{opacity:0.1304;fill:#A7A9AC;}\n\t.st7{opacity:0.1522;fill:#A7A9AC;}\n\t.st8{opacity:0.1739;fill:#A7A9AC;}\n\t.st9{opacity:0.1957;fill:#A7A9AC;}\n\t.st10{opacity:0.2174;fill:#A7A9AC;}\n\t.st11{opacity:0.2391;fill:#A7A9AC;}\n\t.st12{opacity:0.2609;fill:#A7A9AC;}\n\t.st13{opacity:0.2826;fill:#A7A9AC;}\n\t.st14{opacity:0.3043;fill:#A7A9AC;}\n\t.st15{opacity:0.3261;fill:#A7A9AC;}\n\t.st16{opacity:0.3478;fill:#A7A9AC;}\n\t.st17{opacity:0.3696;fill:#A7A9AC;}\n\t.st18{opacity:0.3913;fill:#A7A9AC;}\n\t.st19{opacity:0.413;fill:#A7A9AC;}\n\t.st20{opacity:0.4348;fill:#A7A9AC;}\n\t.st21{opacity:0.4565;fill:#A7A9AC;}\n\t.st22{opacity:0.4783;fill:#A7A9AC;}\n\t.st23{opacity:0.5;fill:#A7A9AC;}\n\t.st24{opacity:0.5217;fill:#A7A9AC;}\n\t.st25{opacity:0.5435;fill:#A7A9AC;}\n\t.st26{opacity:0.5652;fill:#A7A9AC;}\n\t.st27{opacity:0.587;fill:#A7A9AC;}\n\t.st28{opacity:0.6087;fill:#A7A9AC;}\n\t.st29{opacity:0.6304;fill:#A7A9AC;}\n\t.st30{opacity:0.6522;fill:#A7A9AC;}\n\t.st31{opacity:0.6739;fill:#A7A9AC;}\n\t.st32{opacity:0.6957;fill:#A7A9AC;}\n\t.st33{opacity:0.7174;fill:#A7A9AC;}\n\t.st34{opacity:0.7391;fill:#A7A9AC;}\n\t.st35{opacity:0.7609;fill:#A7A9AC;}\n\t.st36{opacity:0.7826;fill:#A7A9AC;}\n\t.st37{opacity:0.8043;fill:#A7A9AC;}\n\t.st38{opacity:0.8261;fill:#A7A9AC;}\n\t.st39{opacity:0.8478;fill:#A7A9AC;}\n\t.st40{opacity:0.8696;fill:#A7A9AC;}\n\t.st41{opacity:0.8913;fill:#A7A9AC;}\n\t.st42{opacity:0.913;fill:#A7A9AC;}\n\t.st43{opacity:0.9348;fill:#A7A9AC;}\n\t.st44{opacity:0.9565;fill:#A7A9AC;}\n\t.st45{opacity:0.9783;fill:#A7A9AC;}\n\t.st46{fill:#A7A9AC;}\n\t.st47{fill:#F1F2F2;}\n\t.st48{fill:#FFFFFF;}\n\t.st49{fill:url(#SVGID_1_);}\n\t.st50{fill:url(#SVGID_00000114057582314539930980000012574070274533844392_);}\n\t.st51{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st52{fill:#455A64;}\n\t.st53{fill:#25D366;}\n"
                }}
            />
            <g>
                <g id="Icon_Shape">
                <defs>
                    <path
                    id="SVGID_00000115503467772401660500000017999720428026101435_"
                    d="M1199.4,912.6c0,6.06-0.18,19.21-0.55,29.36
                            c-0.89,24.85-2.86,56.91-5.84,71.51c-4.48,21.95-11.23,42.67-20.04,59.92c-10.42,20.4-23.72,38.68-39.52,54.45
                            c-15.77,15.74-34.02,28.98-54.39,39.37c-17.34,8.83-38.19,15.6-60.26,20.05c-14.46,2.92-46.28,4.85-70.97,5.73
                            c-10.16,0.36-23.31,0.54-29.35,0.54l-545.1-0.09c-6.06,0-19.21-0.18-29.36-0.55c-24.85-0.89-56.91-2.86-71.52-5.84
                            c-21.95-4.48-42.67-11.23-59.92-20.04c-20.4-10.42-38.68-23.72-54.45-39.52c-15.74-15.77-28.98-34.02-39.37-54.39
                            c-8.84-17.34-15.6-38.19-20.05-60.26c-2.92-14.46-4.85-46.28-5.73-70.97c-0.36-10.16-0.54-23.31-0.54-29.35l0.09-545.1
                            c0-6.06,0.18-19.21,0.55-29.36c0.89-24.85,2.86-56.91,5.84-71.51c4.48-21.95,11.23-42.67,20.04-59.92
                            c10.42-20.4,23.72-38.68,39.52-54.45c15.77-15.74,34.02-28.98,54.39-39.37c17.34-8.83,38.19-15.6,60.26-20.05
                            c14.46-2.92,46.28-4.85,70.97-5.73c10.16-0.36,23.31-0.54,29.35-0.54l545.1,0.09c6.06,0,19.21,0.18,29.36,0.55
                            c24.85,0.89,56.9,2.86,71.51,5.84c21.95,4.48,42.67,11.23,59.92,20.04c20.4,10.42,38.68,23.72,54.45,39.52
                            c15.74,15.77,28.98,34.02,39.37,54.39c8.84,17.34,15.6,38.19,20.05,60.26c2.92,14.46,4.85,46.28,5.73,70.97
                            c0.36,10.16,0.54,23.31,0.54,29.35L1199.4,912.6z"
                    />
                </defs>
                <linearGradient
                    id="SVGID_00000100353571260180977610000001951732803344994204_"
                    gradientUnits="userSpaceOnUse"
                    x1="645.9634"
                    y1="1193.5319"
                    x2="645.9634"
                    y2="86.4803"
                >
                    <stop offset={0} style={{ stopColor: "#25CF43" }} />
                    <stop offset={1} style={{ stopColor: "#61FD7D" }} />
                </linearGradient>
                <use
                    xlinkHref="#SVGID_00000115503467772401660500000017999720428026101435_"
                    style={{
                    overflow: "visible",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    fill:
                        "url(#SVGID_00000100353571260180977610000001951732803344994204_)"
                    }}
                />
                <clipPath id="SVGID_00000125594516287425175530000011982756044510484402_">
                    <use
                    xlinkHref="#SVGID_00000115503467772401660500000017999720428026101435_"
                    style={{ overflow: "visible" }}
                    />
                </clipPath>
                </g>
                <g id="WA_Logo">
                <g>
                    <path
                    className="st51"
                    d="M937.1,351.49c-74.5-74.57-173.58-115.65-279.15-115.69c-217.51,0-394.53,176.96-394.62,394.47
                            c-0.03,69.53,18.14,137.4,52.67,197.22l-55.98,204.43l209.19-54.86c57.64,31.43,122.53,47.99,188.58,48.02h0.16
                            c0.01,0-0.01,0,0,0c217.49,0,394.53-176.98,394.62-394.49C1052.62,525.17,1011.61,426.05,937.1,351.49z M657.96,958.44h-0.13
                            c-58.85-0.02-116.58-15.83-166.94-45.7l-11.98-7.11l-124.14,32.55l33.14-120.99l-7.8-12.4c-32.83-52.21-50.17-112.54-50.15-174.5
                            c0.07-180.79,147.21-327.87,328.13-327.87c87.61,0.03,169.96,34.18,231.88,96.16c61.93,61.98,96.01,144.36,95.98,231.97
                            C985.88,811.35,838.74,958.44,657.96,958.44z M837.87,712.87c-9.86-4.93-58.34-28.78-67.38-32.07
                            c-9.04-3.29-15.61-4.93-22.18,4.93c-6.57,9.87-25.47,32.07-31.22,38.65c-5.75,6.58-11.5,7.4-21.36,2.47
                            c-9.86-4.93-41.63-15.34-79.29-48.92c-29.31-26.14-49.1-58.42-54.85-68.29s-0.61-15.2,4.32-20.12
                            c4.43-4.42,9.86-11.51,14.79-17.27c4.93-5.76,6.57-9.87,9.86-16.45c3.29-6.58,1.64-12.34-0.82-17.27
                            c-2.46-4.93-22.18-53.45-30.4-73.19c-8-19.22-16.13-16.62-22.18-16.92c-5.74-0.29-12.32-0.35-18.9-0.35
                            c-6.57,0-17.26,2.47-26.29,12.33c-9.04,9.87-34.51,33.72-34.51,82.23s35.33,95.39,40.26,101.97
                            c4.93,6.58,69.53,106.14,168.44,148.84c23.52,10.16,41.89,16.22,56.21,20.76c23.62,7.5,45.12,6.44,62.11,3.9
                            c18.94-2.83,58.34-23.85,66.55-46.87c8.22-23.02,8.22-42.76,5.75-46.87C854.3,720.27,847.73,717.8,837.87,712.87z"
                    />
                </g>
                </g>
            </g>
        </svg>
    );
}
